<template>
    <div class="base-card__content base-card__shadow tabs-genres-content base-card__zoom" :class="`tabs-genres-content_${classModifier}`">
        <div class="tabs-genres-content__text">{{ caption }}</div>
    </div>
</template>

<script setup lang="ts">
    import { type PropType, computed } from "vue";
    import { type TabsGenresCardData } from "../../models";

    const props = defineProps({
        cardData: {
            type: Object as PropType<TabsGenresCardData>,
            required: true
        },
    });

    const caption = computed(() => props.cardData.getCaption());
    const classModifier = computed(()=> props.cardData.getClass());
</script>

<style lang="scss">
    @import url("styles.scss");
</style>